import React from "react";
import Header from "../Header";
import "../../../common/styles/dashboard.scss";
import "../../../common/styles/carousel.scss";
import "../../../common/styles/bestcards.scss";
import _ from "lodash";

import { Divider, Tooltip } from "antd";
import {Link} from "react-router-dom";
import { Helmet } from "react-helmet";

import "./FindSecondCard.scss"

import IconBiggerRewards from "../../../assets/images/biggerrewards-valueprop.svg";
import IconBoost from "../../../assets/images/boostyourscore-valueprop.svg";
import IconPerks from "../../../assets/images/perks-valueprop.svg";
import LinkPanels from "../../Home/LinkPanels";
import PersonalizedLinkBanner from "../BestCardsFor/PersonalizedLinkBanner";

import { useRef } from "react";


const FindSecondCard = (args) => {

     // SEO stuff
     const linkRel = ""; // todo what is this
     const title = "Find your second credit card";
     const description = "Getting more cashback, raise your credit score, and get access to premium perks. A second card is not only normal, it is strategic. Find your best card using our proprietary luci algorithm.";

     //
     const sectionRef = useRef(null);

     const scrollToSection = () => {
          sectionRef.current?.scrollIntoView({ behavior: "smooth" });
     };

     // 
     return (

          <div className="dashboard-wrapper">

               <Header/>
               <Helmet>
                    <title>{title}</title>
                    <link rel="canonical" href={linkRel}/>
                    <meta name="description" content={description}/>
                    <meta property="og:title" content={title}/>
                    <meta property="og:description" content={description}/>
                    <meta name="twitter:title" content={title}/>
                    <meta name="twitter:description" content={description}/>
               </Helmet>

               <section>
                    <div className="wrapper profile-sidebar">
                         <div id="content" className="">

                              <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>

                                   {/* banner */}
                                   <div className="find-second-card-banner">
                                        <div className="find-second-card-banner-title">
                                             Looking for your <span style={{color: "orange"}}>second</span> credit card?
                                        </div>
                                        <div className="find-second-card-banner-text">
                                             Getting a second card isn't just normal - it's stategic. Whether you want to maximize cashback or get travel perks, choosing a card that fits your biggest spending category unlocks serious value.
                                        </div>
                                        {/* 
                                        <button className="luci-btn" onClick={scrollToSection}>
                                             Explore Spending Categories
                                        </button>
                                        */}
                                   </div>

                                   {/* value proposition */}
                                   <div className="value-prop">

                                        <div className="value-prop-element">
                                             <div className="value-prop-icon">
                                                  <img src={IconBiggerRewards}/>
                                             </div>
                                             <div className="value-prop-title">
                                                  Get Bigger Rewards
                                             </div>
                                             <div className="value-prop-text">
                                                  Dining out? Buying groceries? Traveling often? There's a card built for exactly that.
                                             </div>
                                        </div>

                                        <Divider type="vertical" style={{ height: "auto", borderColor: "rgba(255, 255, 255, 0.2"}}/>

                                        <div className="value-prop-element">
                                             <div className="value-prop-icon">
                                                  <img src={IconBoost}/>
                                             </div>
                                             <div className="value-prop-title">
                                                  Boost Your Credit Score
                                             </div>
                                             <div className="value-prop-text">
                                                  Lower your credit utilization by increasing your total limit.
                                             </div>
                                        </div>

                                        <Divider type="vertical" style={{ height: "auto", borderColor: "rgba(255, 255, 255, 0.2"}}/>

                                        <div className="value-prop-element">
                                             <div className="value-prop-icon">
                                                  <img src={IconPerks}/>
                                             </div>
                                             <div className="value-prop-title">
                                                  Unlock Premium Perks
                                             </div>
                                             <div className="value-prop-text">
                                                  Get lounge access, rental insurance, extended warranties and more!
                                             </div>
                                        </div>
                                   </div>

                                   {/* links */}
                                   <div ref={sectionRef}>
                                        <LinkPanels isShowTop={false} cardsBySpendTitle={"Explore Credit Cards by Spend"}/>
                                   </div>

                                   {/* personaled banner */}
                                   <div style={{width: "95%"}}>
                                        <PersonalizedLinkBanner/>
                                   </div>
                              </div>
                         </div>
                    </div>
               </section>

          </div>
     );

}


export default FindSecondCard;
